// extracted by mini-css-extract-plugin
export default {"DeveloperTill":"DeveloperTill_DeveloperTill__f1ujL","list":"DeveloperTill_list__5sPR8"};